export const requestsInitialState = {
  requests: null,
  isLoading: true,
  pagination: null,
}
